import  { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import { RootState } from './reducers'
import type { AppDispatch } from './store'
import history from './history'

export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector

export const navigateTo = (location: string) => history.push(location);
